//やるべきこと
//通知内容編集後のバックエンドへのPOSTの実装(PressCreateの実装)
//上記POSTのURLの決定

//電話番号欄の自動置換を実装

<template>
  <div>
    <menubar/>
    <div class="container">
      <div id="title" class="d-flex justify-content-between">
        <div class="d-flex justify-content-start">
          <img src="/img/05_slash.svg"/>
          <p class="h1">クライアント編集</p>
        </div>
      </div>
      <div class="form__wrapper">
        <!-- <form :action="route('clients.update', client.id)" method="post"> -->
        <form @submit.prevent="() => submit(this.trainable_model_list)">
          <div class="form-title h2" v-if="type == 'common'">基本情報</div>
          <div class="table_style top-border bottom-border" v-if="type == 'common'">
            <div class="table_cell_left text-right text-black">
              <div class="multi_left_cell">
                <label for="client_name">クライアント名<span class="text-danger">(必須)</span></label>
              </div>
              <div class="multi_left_cell">
                <label for="client_name_kana">クライアント名カナ<span class="text-danger">(必須)</span></label>
              </div>
            </div>
            <div class="table_cell_right">
              <div class="multi_left_cell">
                <input type="text" id="client_name" v-model="form.name"
                       placeholder="【個人の場合】姓と名の間は、半角スペースを入れてください" required/>
              </div>
              <div class="multi_left_cell">
                <input type="text" id="client_name_kana" v-model="form.name_kana"
                       placeholder="【個人の場合】姓と名の間は、半角スペースを入れてください" required/>
              </div>
            </div>
          </div>

          <div class="table_style bottom-border"  v-if="type == 'common'">
            <div class="table_cell_left text-right text-black">
              <label for="category">カテゴリー<span class="text-danger">(必須)</span></label>
            </div>
            <div class="table_cell_right purple_triangle">
              <select class="client-input" id="category" size="1" v-model="form.category" required>
                <option v-for="category in category_list" :key="category.category">
                  {{ category.category }}
                </option>
              </select>
            </div>
          </div>

          <div class="table_style bottom-border"  v-if="type == 'common'">
            <div class="table_cell_left text-right text-black">
              <div class="multi_left_cell">
                <label for="organization_name">事業部・組織名など</label>
              </div>
              <div class="multi_left_cell">
                <label for="organization_kana">事業部・組織名などカナ</label>
              </div>
            </div>
            <div class="table_cell_right">
              <div class="multi_left_cell">
                <input type="text" id="organization_name" class="client-input"
                       v-model="form.organization_name"/>
              </div>
              <div class="multi_left_cell">
                <input type="text" id="organization_kana" class="client-input"
                       v-model="form.organization_kana"/>
              </div>
            </div>
          </div>

          <div class="form-title h2 pt-3" v-if="type == 'contractor'">契約者<span class="h5 fw-bold">(請求書送付先)</span></div>
          <div class="table_style top-border bottom-border"  v-if="type == 'contractor'">
            <div class="table_cell_left text-right text-black">
              <div class="multi_left_cell">
                <label for="contractor_name">氏名<span class="text-danger">(必須)</span></label>
              </div>
              <div class="multi_left_cell">
                <label for="contractor_kana">氏名カナ<span class="text-danger">(必須)</span></label>
              </div>
            </div>
            <div class="table_cell_right">
              <div class="multi_left_cell">
                <input type="text" id="contractor_name" class="client-input"
                       v-model="form.contractor_name" placeholder="姓と名の間は、半角スペースを入れてください" required/>
              </div>
              <div class="multi_left_cell">
                <input type="text" id="contractor_kana" class="client-input"
                       v-model="form.contractor_kana" placeholder="姓と名の間は、半角スペースを入れてください" required/>
              </div>
            </div>
          </div>

          <div class="table_style bottom-border" v-if="type == 'contractor'">
            <div class="table_cell_left text-right text-black">
              <div class="multi_left_cell">
                <label for="division_name">部署名</label>
              </div>
              <div class="multi_left_cell">
                <label for="division_kana">部署名などカナ</label>
              </div>
            </div>
            <div class="table_cell_right">
              <div class="multi_left_cell">
                <input type="text" id="division_name" class="client-input"
                       v-model="form.division_name"/>
              </div>
              <div class="multi_left_cell">
                <input type="text" id="division_kana" class="client-input"
                       v-model="form.division_kana"/>
              </div>
            </div>
          </div>

          <div class="table_style bottom-border"  v-if="type == 'contractor'">
            <div class="table_cell_left text-right text-black">
              <div class="multi_left_cell">
                <label for="position_name">役職</label>
              </div>
              <div class="multi_left_cell">
                <label for="position_kana">役職などカナ</label>
              </div>
            </div>
            <div class="table_cell_right">
              <div class="multi_left_cell">
                <input type="text" id="position_name" class="client-input"
                       v-model="form.contractor_position_name"/>
              </div>
              <div class="multi_left_cell">
                <input type="text" id="position_kana" class="client-input"
                       v-model="form.contractor_position_kana"/>
              </div>
            </div>
          </div>

          <div class="table_style bottom-border"  v-if="type == 'contractor'">
            <div class="table_cell_left text-right text-black">
              <div class="multi_left_cell">
                <label for="zip1">郵便番号</label>
              </div>
              <div class="multi_left_cell">
                <label for="address_name">住所</label>
              </div>
              <div class="multi_left_cell">
                <label for="address_kana">住所カナ</label>
              </div>
            </div>
            <div class="table_cell_right">
              <div class="multi_left_cell">
                <input type="text" id="zip1" class="zip-input" v-model="form.zip1" maxlength="3"
                       @change="() => search_address_from_zipcode(form)"/> ー
                <input type="text" id="zip2" class="zip-input" v-model="form.zip2" maxlength="4"
                       @change="() => search_address_from_zipcode(form)"/>
                <span class="placeholder__zipcode">(郵便番号を入れると、住所が自動的に入ります)</span>
              </div>
              <div class="multi_left_cell">
                <input type="text" id="address_name" class="client-input" v-model="form.address_name"/>
              </div>
              <div class="multi_left_cell">
                <input type="text" id="address_kana" class="client-input" v-model="form.address_kana"/>
              </div>
            </div>
          </div>

          <div class="table_style bottom-border"  v-if="type == 'contractor'">
            <div class="table_cell_left text-right text-black">
              <label for="phone_number">電話番号<span class="text-danger">(必須)</span></label>
            </div>
            <div class="table_cell_right">
              <input type="tel" id="phone_number" class="client-input"
                     v-model="form.contractor_phone_number" maxlength="13"
                     placeholder="ハイフン(-)と数字のみで入力してください" required/>
            </div>
          </div>

          <div class="table_style bottom-border" v-if="type == 'contractor'">
            <div class="table_cell_left text-right text-black">
              <label for="contractor_email">メールアドレス<span class="text-danger">(必須)</span></label>
            </div>
            <div class="table_cell_right">
              <input type="email" id="contractor_email" class="client-input"
                     v-model="form.contractor_email" required/>
            </div>
          </div>

          <div class="form-title h2 pt-3" v-if="type == 'owner'">オーナー</div>
          <div class="table_style top-border bottom-border"  v-if="type == 'owner'">
            <div class="table_cell_left text-right text-black">
              <label for="owner_name">登録ユーザー名<span class="text-danger">(必須)</span></label>
            </div>
            <div class="table_cell_right">
              <input type="text" id="owner_name" class="client-input"
                     v-model="form.owner_name" placeholder="姓と名の間は、半角スペースを入れてください" required/>
            </div>
          </div>

          <div class="table_style bottom-border" v-if="type == 'owner'">
            <div class="table_cell_left text-right text-black">
              <label for="owner_email">メールアドレス<span class="text-danger">(必須)</span></label>
            </div>
            <div class="table_cell_right">
              <input type="email" id="owner_email" class="client-input"
                     v-model="form.owner_email" required/>
            </div>
          </div>

          <div class="form-title h2 pt-3" v-if="type == 'contract'">契約状況</div>
          <!-- <div class="table_style bottom-border">
            <div class="table_cell_left text-right text-black">
              <label for="status">ステータス<span class="text-danger">(必須)</span></label>
            </div>
            <div class="table_cell_right purple_triangle">
              <select name="status_list" class="client-input" size="1" v-model="form.status">
                <option v-for="status in status_list" :key="status.status">
                  {{ status.status }}
                </option>
              </select>
            </div>
          </div> -->

          <div class="table_style bottom-border"  v-if="type == 'contract'">
            <div class="table_cell_left text-right text-black">
              <label for="plan">プラン<span class="text-danger">(必須)</span></label>
            </div>
            <div class="table_cell_right purple_triangle">
              <select id="plan" class="client-input" size="1" v-model="form.contract_plan_id" required>
                <option v-for="plan in plan_list" :key="plan.id" :value="plan.id">
                  {{ plan.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="table_style bottom-border" v-if="type == 'contract'">
            <div class="table_cell_left text-right text-black">
              <label for="beginning_date">利用開始日<span class="text-danger">(必須)</span></label>
            </div>
            <div class="table_cell_right">
              <input type="date" min="2000-01-01" max="2035-12-31" id="beginning_date" class="client-input input__date"
                     v-model="form.beginning_date" required/>
            </div>
          </div>

          <div class="table_style bottom-border" v-if="type == 'contract'">
            <div class="table_cell_left text-right text-black">
              <label for="expiration_date">利用停止日<span class="text-danger">(必須)</span></label>
            </div>
            <div class="table_cell_right">
              <input type="date" min="2000-01-01" max="2035-12-31" id="expiration_date" class="client-input input__date"
                     v-model="form.expiration_date" required/>
            </div>
          </div>

          <!--TODO:不明なフォーム-->
          <div class="form-title h2 pt-3" v-if="type == 'user_id'">ユーザーID</div>
          <div class="table_style top-border bottom-border" v-if="type == 'user_id'">
            <div class="table_cell_left text-right text-black">
              <label for="user_id_number">上限数<span class="text-danger">(必須)</span></label>
            </div>
            <div class="table_cell_right purple_triangle_id">
              <select name="user_id_number" class="client-input" size="1"
                      v-model="form.max_number_of_users" required>
                <option v-for="(_,user_id) in [...Array(999)]" v-bind:key="user_id">
                  {{ user_id + 1 }}
                </option>
              </select>
            </div>
          </div>

          <!--
          
            AI モデル編集

          -->
          <div class="form-title h2 pt-3" v-if="type == 'ai_model'">AIモデル</div>

          <table class="table infromation-table"  v-if="type == 'ai_model'">
            <tbody>
              <tr style="width: 100%">
                <th colspan="2" rowspan="1">
                  <div class="table-header"> 契約モデル一覧 </div>
                  <table class="aimodel_table component_table" cellpadding="5">
                    <thead>
                      <tr>
                        <th class="th--aimodel-name">モデル名</th>
                        <th class="th--language-pair">言語ペア</th>
                        <th class="th--description">説明</th>
                        <th class="th--checkbox">選択</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="aimodel in all_aimodel_list" :id="aimodel.id">
                        <td class="td--aimodel-name">{{ aimodel.name }}</td>
                        <td>
                          {{ aimodel.src_language_code }} → {{ aimodel.trg_language_code }}
                        </td>
                        <td 
                          v-bind:class="[showing_aimodel_description_ids.includes(aimodel.id) ? 'td--description' : 'td--description__hidden']" 
                          @click="switchAimodelDescription(aimodel.id)"
                        >
                          {{ aimodel.description }}
                        </td>
                        <td class="td--checkbox">
                          <input
                            type="checkbox" 
                            :id="aimodel.id" 
                            :value="aimodel.id" 
                            @click="checked()"
                            v-model="form.selectedAimodels"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </th>
              </tr>

              <tr>
                <th class="infromation-table__th">
                  <div class="table-header">
                    学習データ提供契約
                  </div>
                </th>
                <td class="infromation-table__td">
                  <div class="table-data">
                    <input
                      type="checkbox"
                      id="proposal_data"
                      class="visually-hidden"
                      v-model="form.is_allowed_training_data_provision"
                    />
                    <label class="custom-input-label" for="proposal_data">
                      {{ form.is_allowed_training_data_provision ? "あり" : "なし" }}
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>


          <div class="table_style modal-btn d-flex justify-content-center div__transitionbutton">
            <Link class="btn btn-red btn-cans div__transitionbutton--link"
                  :href="route('clients.show', client.id)">
              キャンセル
            </Link>
            <input type="submit" class="btn btn-purple btn-add div__transitionbutton--link" value="保存する"
                   v-on:click="PressCreate"/>
          </div>
        </form>
      </div>
    </div>
    <footer-component/>
  </div>
</template>

<script>
import {Inertia} from '@inertiajs/inertia'
import {defineComponent, reactive} from 'vue';
import modal from '@/Pages/Components/modal.vue';
import menubar from '@/Pages/JVTA/menu_jvta.vue';
import footerComponent from '@/Pages/Components/footer.vue';
import {Link} from '@inertiajs/inertia-vue3'
import $ from 'jquery';

export default defineComponent({
  components: {
    menubar,
    modal,
    footerComponent,
    Link,
  },
  setup(props) {
    let client = props.client;
    const users = client.users || [];
    const owner = users.find(user => user.user_type && user.user_type.name === 'オーナー')
        || users.find(user => Number(user.user_type_id) === 1);

    const form = reactive({
      // バックエンドに送信するデータ群
      edit_type: props.type,
      id: client.id,
      name: client.name,
      name_kana: client.name_kana,
      category: client.category,
      organization_name: client.organization_name,
      organization_kana: client.organization_kana,

      postal_code: client.postal_code,
      contractor_name: client.contractor_name,
      contractor_kana: client.contractor_kana,
      contractor_position_name: client.contractor_position_name,
      contractor_position_kana: client.contractor_position_kana,
      contractor_email: client.contractor_email,
      contractor_phone_number: client.contractor_phone_number,
      owner_name: owner ? owner.name : '',
      owner_email: owner ? owner.email : '',
      division_name: client.division_name,
      division_kana: client.division_kana,
      zip1: client.postal_code ? client.postal_code.slice(0, 3) : "",
      zip2: client.postal_code ? client.postal_code.slice(3, 7) : "",
      address_name: client.address_name,
      address_kana: client.address_kana,
      is_allowed_training_data_provision: client.is_allowed_training_data_provision==1,

      status: client.status,

      contract_plan_id: client.client_contract_plan.contract_plan_id,
      max_number_of_users: client.client_contract_plan.max_number_of_users,
      max_number_of_aimodels: client.client_contract_plan.max_number_of_aimodels,
      beginning_date: client.client_contract_plan.beginning_date,
      expiration_date: client.client_contract_plan.expiration_date,

      selectedAimodels: client.aimodels.length > 0 ? new Array(...client.aimodels).map(aimodel => {return aimodel.id}) : [],
    })

    function validate() {
      switch (props.type) {
        case 'owner':
          if (!form.owner_name || !form.owner_email) {
            return "オーナー情報を入力してください";
          }
          break;
        case 'contractor':
          if (form.postal_code && !form.postal_code.match(/^[0-9]{7}$/)) {
            return "郵便番号は7桁の半角数字にしてください";
          }
          if (!form.contractor_phone_number.match(/^[0-9\-]+$/)) {
            return "電話番号は半角数字、ハイフン(-)のみで構成してください";
          }
          break;
        case 'contract':
          if (!(form.beginning_date <= form.expiration_date)) {
            return "利用開始日が利用終了日より遅いです"
          }
          if ((form.additional_contract_flag == true && form.additional_contract.beginning_date > form.additional_contract.expiration_date)){
            return "追加契約の利用開始日が利用終了日より遅いです"
          }
          break;
        case 'user_id':
          if (client.users.length > form.max_number_of_users) {
            return "登録しているユーザー数が最大ユーザー数が超過しています"
          }
          break;
      }

      return "";
    }

    function submit() {

      form.postal_code = form.zip1 + form.zip2

      let validation = validate();
      if (validation !== "") {
        alert(validation);
        return;
      }
      console.log(form.selectedAimodels);

      // type が 'contract' のときだけ expiration_date をセット
      if (props.type !== 'contract') {
        delete form.expiration_date;
        delete form.beginning_date;
      }

      // 利用開始停止日がタイムゾーンによって変わるため、タイムゾーンをバックエンドに渡す
      form.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      Inertia.put('/clients/' + form.id, form);
    }

    return {form, submit}
  },
  props: {
    //このフラグに応じて編集する要素を区別している
    type: String, //common,contractor,owner,contract,userId,AImodel,salesManagement
    client: Object,
    plan_list: Array,
    all_aimodel_list: Array,
  },
  data() {
    return {
      category_list: [{category: '映画制作'}, {category: '翻訳事業'}, {category: '海外支店'}, {category: '企業'}],
      showing_aimodel_description_ids: [],
    };
  },
  methods: {
    switchAimodelDescription(id){
      if (this.showing_aimodel_description_ids.includes(id)){
        this.showing_aimodel_description_ids.splice(this.showing_aimodel_description_ids.indexOf(id), 1);
      }else{
        this.showing_aimodel_description_ids.push(id);
      }
    },
    checked(){
      console.log(this.form.selectedAimodels);
    },
    // 表の行追加
    add: function (invoice_items) {
      const nextId = this.form.invoice_items.length == 0 ? 1 : Math.max(...this.form.invoice_items.map((p) => p.id)) + 1;
      invoice_items.push(
        {
          client_id: this.form.id,
          id: nextId,
          name: 'New Invoice item',
          date_year: new Date().getFullYear(),
          date_month: new Date().getMonth() + 1,
          unit_price: 0,
          quantity: 1,
          is_paid: false,
          paid_at: null,
        }
      );
    },
    item_delete: function (id) {
      if (window.confirm('削除してもよろしいですか？')) {
        const new_additional_contract = this.form.invoice_items.filter(n => n.id !== id);
        this.form.invoice_items = new_additional_contract;
      }
    },
    PressCreate: function () {
      console.log('hogehgoe');
    },
    countTotalPrice(paid_information) {
      console.log(paid_information);
      return paid_information.filter(e => !e.is_paid).map(e => e.unit_price * e.quantity).reduce((a, b) => a + b, 0);
    },
    countTotalContractPrice(paid_information) {
      return paid_information.map(e => e.unit_price * e.quantity).reduce((a, b) => a + b, 0);
    },
    replaceKanaHalfToFull : function(str) {
      var kanaMap = {
        'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
        'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
        'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
        'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
        'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
        'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
        'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
        'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
        'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
        'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
        'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
        'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
        'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
        'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
        'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
        'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
        'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
        'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
        '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
      };
      let reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
      return str.replace(reg, function(s){
        return kanaMap[s];
      }).replace(/ﾞ/g, '゛').replace(/ﾟ/g, '゜');
    },
    search_address_from_zipcode: function () {
      if (this.form.zip1 != undefined && this.form.zip2 != undefined){
        if(this.form.zip1.length === 3 && this.form.zip2.length === 4) {
          var url = 'https://zipcloud.ibsnet.co.jp/api/search?zipcode=' + this.form.zip1 + this.form.zip2;

          // jQuery ajaxで同期処理
          $.ajax({
            url: url,
            dataType: 'json',
            async: false,
            success: (response) => {
              if (response.status === 200) {
                //200 -> 取得成功
                let resData = response.results;
                this.form.address_name = resData[0]['address1'] + resData[0]['address2'] + resData[0]['address3'];
                this.form.address_kana = this.replaceKanaHalfToFull(resData[0]['kana1'] + resData[0]['kana2'] + resData[0]['kana3']);
              }
              else{
                 var msg = 'Status Code:' + response.status + ' (' + response.message + ')';
                 window.alert('郵便番号からの住所検索に失敗しました。' + '\n' + msg);
              }
            },
            error: function (response) {
              var msg = 'Status Code:' + response.status + ' (' + response.message + ')';
              window.alert('郵便番号からの住所検索に失敗しました。' + '\n' + msg);
            },
          });
        }
      }
    },
  },
});
</script>

<style lang="scss" scoped>
// タイトル部分「用語集一覧」のcss
.container {
  min-height: 80vh;

  #title {
    margin: 3rem 0;

    img {
      width: 3rem;
      height: 3rem;
    }

    p {
      color: #333333;
    }
  }
  margin-bottom: 3rem;
}

.form__wrapper {
  width: 100%;
  margin: auto;
  border: 1px solid #b1b0b0;
  border-radius: 10px;
  padding-top: 0.25rem;
  padding-left: 3rem;
  padding-right: 3rem;
  font-size: 13px;
  color: #666666;
  background-color: #ffffff;
  /* font-weight: normal; */
  /*　（全角+半角）の文字で改行しないように */
  white-space: nowrap;
}

.table_style {
  width: 100%;
  padding: 1rem 0;
  display: table;
}

.table_cell_left {
  border-right: 1px solid #b1b0b0;
  display: table-cell;
  vertical-align: middle;
  padding-right: 1rem;
  padding-left: 1rem;
}

.table_cell_right {
  display: table-cell;
  vertical-align: middle;
  padding-left: 1rem;
  padding-right: 1rem;
}

.text-right {
  width: 14rem;
  max-width: 13rem;
}

.text-left {
  width: 0px;
  text-align: left;
}

.left-padding {
  padding-left: 15px;
}

.bottom-border {
  border-bottom: 1px dotted #b1b0b0;
}

.top-border {
  border-top: 1px dotted #b1b0b0;
}

.username {
  padding-top: 10px;
  height: 40px;
}

#title img {
  width: 3rem;
  height: 3rem;
}

#title p {
  color: #666666;
}

.container {
  min-height: 80vh;
}

// .table {
//   table-layout: fixed;
//   overflow-wrap: break-word;
//   word-wrap: break-word;
// }

#client_name,
#client_name_kana,
.client-input {
  width: 100%;
  border: 1px solid #b1b0b0;
  border-radius: 5px;
}

.zip-input,
.userId__input {
  border: 1px solid #b1b0b0;
  border-radius: 5px;
  width: 97%;
}

.reserve_time_input {
  margin-left: 3rem;
}

.btn-and-btn {
  text-align: center;
}

.custom-input-label {
  position: relative;
  cursor: pointer;
  padding-top: 0.5rem;
  padding-left: 30px;
  min-width: 100px;
}

.custom-input-label::before,
.custom-input-label::after {
  content: '';
  display: block;
  border-radius: 50%;
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
}

.custom-input-label::before {
  background-color: #fff;
  border: 1.5px solid #ddd;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  left: 5px;
}

.custom-input-label::after {
  background-color: rgb(0, 0, 0);
  border-radius: 50%;
  opacity: 0;
  width: 16px;
  height: 16px;
  left: 7px;
}

input:checked + .custom-input-label::after {
  opacity: 1;
}

.visually-hidden {
  position: absolute;
  white-space: nowrap;
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  overflow: hidden;
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0;
}

#zip1 {
  width: 3rem;
}

#zip2 {
  width: 3.5rem;
}

.form-title {
  font-weight: bold;
  padding-left: 1rem;
  padding-right: 1rem;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.price_total_column {
  min-width: 85%;
}

.tb_date {
  width: 9rem;
  height: 2rem;
}

.tb_single_price {
  width: 8rem;
  min-width: 20%;
}

.tb_single_price_bool {
  width: 8rem;
  min-width: 20%;
}

.tb_single_paid_date {
  width: 8rem;
  min-width: 20%;
}

.tb_single_paid_date_bool {
  width: 4rem;
  min-width: 20%;
}

.tb__delete {
  width: 7rem;
  min-width: 20%;
}

.txt-danger {
  font-weight: bold;
  color: red;
}


.add-button {
  margin-top: 2rem;
  margin-left: 3rem;
  width: 10rem;
}

.multi_left_cell {
  padding: 1rem 0;
}

.add-button img {
  width: 1rem;
}

//三角ボタンの実装

.purple_triangle > select,
.purple_triangle_id > select {
  -webkit-appearance: none;
  appearance: none; /* デフォルトのスタイルを無効 */
  width: 10rem;
  color: #999;
  font-size: 1rem;
  padding: 0 1rem;


  width: 15rem;
  margin-left: 5px;
  color: #999;
  font-size: 12px;
  padding: 7px 30px 7px 10px;
  border-radius: 5px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  &::-ms-expand {
    display: none;
  }

  background-image: url(/img/16_tri.svg);
  background-repeat: no-repeat;
  background-size: 24px 12px;
  background-position: right 10px center;
}

.purple_triangle > select::-ms-expand,
.purple_triangle_id > select::-ms-expand {
  display: none; /* デフォルトのスタイルを無効(IE用) */
  width: 10rem;
  color: #999;
  font-size: 1rem;
  padding: 0 1rem;
}

input[type="text"], input[type="tel"], input[type="date"], input[type="email"], input[type="number"], label {
  padding: 0.25rem;
  height: 2rem;
  min-height: 1.25rem;
}

.input__date {
  position: relative;
  max-width: 8rem;
  background-image: url('/img/calendar_icon.svg');
  background-repeat: no-repeat;
  background-size: 1.25rem;
  background-position: right 0.5rem center;
  // padding: 0.25rem 2rem 0.2rem 0.5rem;
  // height: 2.5rem;
  margin-left: 0.25rem;
}

.input__date::-webkit-calendar-picker-indicator {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.placeholder__zipcode {
  padding-left: 1.5rem;
}

span[class="text-danger"] {
  padding-left: 0.5rem;
}

.model__name {
  padding-right: 1rem;
  min-width: 20rem;
  margin: 0.25rem auto;
}

.input__unitPrice {
  margin-right: 0.5rem;
  text-align: right;
}

select[class="client-input"] {
  max-width: 10rem;
  background-color: transparent;
}

.div__transitionbutton--link {
  margin: auto 2rem;
}

.invoice_table {
  width: 48%;
  margin: 6.5rem 4rem 0;
  table-layout: fixed;
}

.userId__input--price {
  width: 90%;
  text-align: right;
}

.userId__input--year {
  width: 4rem;
}

.userId__input--month {
  width: 3rem;
}

.btn__red--delete {
  font-size: 0.75rem;
}

//=[AIモデル一覧テーブル]====================================================//
.aimodel_table {
  width: 100%;
  table-layout: fixed;
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: normal;
  thead {text-align: center;}
  td {padding: 0.5rem 1rem;}
  tbody {text-align: center;}
  .td--aimodel-name{
  width: 100rem;
  text-align: left;
  }

}

.th--aimodel-name{width: 20%}
.th--language-pair{width: 6rem;}
.th--description{width: auto;}
.th--checkbox{width: 4rem;}
.td--description{
  text-align: left;
  word-wrap: break-word;
}
.td--description__hidden{
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
$gray_e4: #e4e4e3;
$gray_b1: #b1b0b0;
$gray_66: #666;
$gray_33: #333;
.infromation-table__th{
  color: $gray_33;
  border-top: 1px dotted;
  border-bottom: 1px dotted;
  border-color: $gray_e4;
  height: 100%;
  width: 20%;
  padding: 1rem;
}
.infromation-table__td{
  border-top: 1px dotted;
  border-bottom: 1px dotted;
  border-color: $gray_e4;
  padding: 1rem 0rem;
  color: $gray_66;

}

.div__tableLeft{
  margin: 0.25rem auto;
}
//==========================================================================//
</style>
